import get from 'transmute/get';
export function getIsChannelInstanceFetchedById({
  channelInstances
}, {
  channelInstanceId
}) {
  if (!channelInstanceId) return false;
  const currentlyBeingFetchedIds = get('currentlyFetchingInstanceIds', channelInstances);
  return currentlyBeingFetchedIds.contains(channelInstanceId);
}